module.exports = __webpack_public_path__ + "img/20190610161609QQ截图20190603165751.fada86bf.png";